export default __webpack_public_path__ + "static/media/loginbg2.f89a238d.png";